module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "temporaryLecturePanel"
    }
  }, [_c('div', [_c('p', [_vm._v("生徒のお名前")]), _vm._v(" "), _c('div', {
    staticClass: "student-name-block"
  }, [_c('div', [_c('p', [_vm._v("氏名(必須)　　："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }],
    attrs: {
      "id": "fullname",
      "type": "text"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }, _vm.handleNameInput]
    }
  })]), _vm._v(" "), _c('p', [_vm._v("フリガナ(任意)："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kana),
      expression: "kana"
    }],
    attrs: {
      "id": "kana",
      "type": "text"
    },
    domProps: {
      "value": (_vm.kana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.kana = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', [_vm._t("default")], 2), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("配布物（確認テスト等）: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasTest),
      expression: "hasTest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasTest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n      有り\n    ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n      無し\n    ")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOnline),
      expression: "isOnline"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOnline) ? _vm._i(_vm.isOnline, null) > -1 : (_vm.isOnline)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isOnline,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOnline = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOnline = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOnline = $$c
        }
      }
    }
  }), _vm._v(" オンライン授業"), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "message",
      "placeholder": "連絡事項"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isEdit) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reserve()
      }
    }
  }, [_vm._v("予約する")]) : [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reserve()
      }
    }
  }, [_vm._v("編集の完了をする")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "eraseButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteResv()
      }
    }
  }, [_vm._v("予約の削除をする")])], _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel()
      }
    }
  }, [_vm._v("キャンセル")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d6ec2ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/TemporaryLecturePanel.vue
// module id = 668
// module chunks = 0